import React from 'react';
import './OurStory.css';
import ContentSection from '../components/ContentSection';
import ImageGrid from '../components/ImageGrid';
import Sponsorships from '../components/Sponsorships';
import contentImage1 from '../assets/our_story/fresh to your plate.jpg';
import contentImage2 from '../assets/our_story/a local favorite.jpg';
import stepInside0 from '../assets/our_story/step inside 0.jpg';
import stepInside1 from '../assets/our_story/step inside 1.jpg';
import stepInside2 from '../assets/our_story/step inside 2.jpg';

const OurStory = () => {
  return (
    <div className="our-story-page">
      <div className="our-story">
        <h1 className="main-title">The Highlands Tradition</h1>
        
        <div className="history-section">
          <div className="history-content">
            <h2 className="history-title">Highlands Sports Bar and Grill: A Taste of San Carlos</h2>
            <p className="history-text">
              Welcome to Highlands Sports Bar & Grill, where great food, good times, and a genuine love for what we do come together. Located right in the heart of San Carlos, CA, we're all about bringing the community together over some seriously delicious meals. From our signature burgers and hand-crafted pizzas to fresh, locally sourced salads and mouthwatering seafood, every dish is made with one goal in mind: to offer something you'll love and want to come back for.
            </p>
          </div>
        </div>

        <Sponsorships isDarkMode={true} />

        {/* <ContentSection
          title="Fresh From Our Community to Your Plate"
          description="What sets us apart is the simple but powerful philosophy behind everything we do. We focus on using the best ingredients that are locally sourced, making sure every dish reflects the flavors and freshness of our community. Our meats are handpicked from local butchers, and our veggies come straight from nearby farms. That means when you eat here, you're not just enjoying a meal; you're supporting the local businesses and farmers who help make it all possible. "
          image={contentImage1}
          imageAlt="Delicious breakfast tacos with scrambled eggs, bacon, avocado, and cilantro"
          imageOnRight={false}
        />

        <ContentSection
          title="A Local Favorite with Heart"
          description="Since opening, Highlands Sports Bar & Grill has become a local favorite. It's not just about the food — it's about the experience. Our customers are part of the Highlands family, whether for a casual lunch or a big family dinner. We pride ourselves on creating a welcoming environment and going the extra mile to ensure great experiences. We're grateful for the community's support and love hosting events while giving back to the area that has given us so much."
          image={contentImage2}
          imageAlt="Delicious breakfast tacos with scrambled eggs, bacon, avocado, and cilantro"
          imageOnRight={true}
        />

        <ImageGrid
          title="Step Inside the Highlands Sports Bar & Grill Vibe"
          description="From our lively outdoor seating to the cozy, welcoming interior, experience the perfect spot for great food, drinks, and good times with friends."
          images={[
            { src: stepInside0, alt: "Highlands Sports Bar & Grill outdoor seating area" },
            { src: stepInside1, alt: "Highlands Sports Bar & Grill interior dining space" },
            { src: stepInside2, alt: "Highlands Sports Bar & Grill bar area" }
          ]}
        /> */}
      </div>
    </div>
  );
};

export default OurStory; 